// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
//import Person from "@material-ui/icons/Person";
 import PhoneIphone from "@material-ui/icons/PhoneIphone";
 import Shop from "@material-ui/icons/Shop";
 import DeveloperBoard from "@material-ui/icons/DeveloperBoard";
 import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption';
 import CastForEducationIcon from '@material-ui/icons/CastForEducation';
// import ContentPaste from "@material-ui/icons/ContentPaste";
// import LibraryBooks from "@material-ui/icons/LibraryBooks";
// import BubbleChart from "@material-ui/icons/BubbleChart";
// import LocationOn from "@material-ui/icons/LocationOn";
// import Notifications from "@material-ui/icons/Notifications";
// core components/views
import DashboardPage from "views/Dashboard/Dashboard.jsx";
import MobileDirect from "views/MobileDirect/MobileDirect.jsx";
import EnterpriseSolutions from "views/EnterpriseSolutions/EnterpriseSolutions.jsx";
import AISolutions from "views/AISolutions/AISolutions.jsx";
import EdTech from "views/EdTech/EdTech.jsx";
import HealthTech from "views/HealthTech/HealthTech.jsx";
//import UserProfile from "views/UserProfile/UserProfile.jsx";
// import TableList from "views/TableList/TableList.jsx";
// import Typography from "views/Typography/Typography.jsx";
// import Icons from "views/Icons/Icons.jsx";
// import Maps from "views/Maps/Maps.jsx";
// import NotificationsPage from "views/Notifications/Notifications.jsx";

const dashboardRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Products Dashboard",
    navbarName: "Products Dashboard",
    icon: Dashboard,
    component: DashboardPage
  },
  {
    path: "/mobibledirectmarketing",
    sidebarName: "Mobile & Direct Marketing",
    navbarName: "Mobile & Direct Marketing",
    icon: PhoneIphone,
    component: MobileDirect
  },
  {
    path: "/enterprise-solutions",
    sidebarName: "Enterprise Solutions",
    navbarName: "Enterprise Solutions",
    icon: Shop,
    component: EnterpriseSolutions
  },
  {
    path: "/ai-solutions",
    sidebarName: "AI & IoT Solutions ",
    navbarName: "AI & IoT Solutions",
    icon: DeveloperBoard,
    component: AISolutions
  },
  {
    path: "/ed-tech",
    sidebarName: "EdTech Solutions",
    navbarName: "EdTech Solutions",
    icon: CastForEducationIcon,
    component: EdTech
  },
  {
    path: "/health-tech",
    sidebarName: "HealthTech Solutions",
    navbarName: "HealthTech Solutions",
    icon: EnhancedEncryptionIcon,
    component: HealthTech
  },
  // {
  //   path: "/user",
  //   sidebarName: "User Profile ",
  //   navbarName: "User Profile",
  //   icon: Person,
  //   component: UserProfile
  // },
  // {
  //   path: "/table",
  //   sidebarName: "Table List",
  //   navbarName: "Table List",
  //   icon: "content_paste",
  //   component: TableList
  // },
  // {
  //   path: "/typography",
  //   sidebarName: "Typography",
  //   navbarName: "Typography",
  //   icon: LibraryBooks,
  //   component: Typography
  // },
  // {
  //   path: "/icons",
  //   sidebarName: "Icons",
  //   navbarName: "Icons",
  //   icon: BubbleChart,
  //   component: Icons
  // },
  // {
  //   path: "/maps",
  //   sidebarName: "Maps",
  //   navbarName: "Map",
  //   icon: LocationOn,
  //   component: Maps
  // },
  // {
  //   path: "/notifications",
  //   sidebarName: "Notifications",
  //   navbarName: "Notifications",
  //   icon: Notifications,
  //   component: NotificationsPage
  // },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx